module.exports = __webpack_public_path__ + "static/media/sign-up-background.d1a2dcd6.png";